<template>
    <div
        id="form-page"
        v-bind:class="{
            'already-answered': is('alreadyAnswered') || is('hasUnusedCoupon'),
            'embed': embed
        }"
    >
        <header v-if="!is('loading') && !embed">
            <img :src="place.logo" alt=""/>
        </header>
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-md-5 col-sm-12">
                    <form action="">
                        <template v-if="is('loading')">
                            <div class="intro">
                                <span class="fa fa-spin fa-spinner"></span>
                            </div>
                        </template>
                        <template v-if="is('answering')">
                            <div class="form-intro" v-if="title || description">
                                <h3 v-if="title">{{ title }}</h3>
                                <p v-if="description">{{ description }}</p>
                            </div>
                            <div class="steps" ref="stepsHolder">
                                <form-step
                                    ref="steps"
                                    v-for="(step, key) in steps"
                                    :key="step.id"
                                    :questions="step.questions"
                                    :form-id="id"
                                    :class="{ active: isStepActive(key) }"
                                    @scroll="scrollStep"
                                />
                                <div
                                    class="form-step active"
                                    v-if="showClientForm"
                                >
                                    <user-form
                                        :client="client"
                                        :place="place"
                                        @saved="clientUpdated"
                                        ref="formUser"
                                    ></user-form>
                                </div>
                            </div>
                            <button
                                class="btn btn-lg btn-success pull-right btn-continue"
                                @click.prevent="next"
                                :disabled="saving"
                            >
                                <span
                                    class="fa fa-spinner fa-spin"
                                    v-if="saving"
                                ></span>
                                Enviar
                            </button>
                        </template>
                        <template v-if="is('saved')">
                            <div
                                class="thanks"
                                v-bind:style="{ background: place.color }"
                            >
                                <template v-if="coupon">
                                    <div class="coupon alert alert-info">
                                        <div class="prize">
                                            {{ client.first_name }}, você acaba
                                            de ganhar
                                            <strong>{{ coupon.text }}</strong>
                                            na sua próxima compra!
                                        </div>
                                        <div class="coupon-code">
                                            {{ coupon.code }}
                                        </div>
                                        <div class="note">
                                            Cupom válido até
                                            {{ coupon.expiration_date }} <br/>
                                        </div>
                                    </div>
                                    <div class="how-to-receive">
                                        {{ coupon.how_to_use }}
                                        <div class="kevi-credits">
                                            Desenvolvido com
                                            <a
                                                href="https://kevi.io"
                                                target="_blank"
                                            >Kevi.io</a
                                            >
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="coupon alert alert-info">
                                        <div class="coupon-code">Obrigado!</div>
                                        <div class="note">
                                            Sua opinião é muito importante!
                                        </div>
                                    </div>
                                    <div class="kevi-credits">
                                        Desenvolvido com
                                        <a
                                            href="https://kevi.io"
                                            target="_blank"
                                        >Kevi.io</a
                                        >
                                    </div>
                                </template>
                            </div>
                        </template>
                        <template v-if="is('notFound')">
                            <div class="intro">
                                <span>
                                    <span class="fa fa-close"></span> Formulário
                                    não encontrado.</span
                                >
                            </div>
                        </template>
                        <template v-if="is('alreadyAnswered')">
                            <div class="intro already-answered">
                                <div class="block">
                                    <span class="icon icon-sad"></span> <br/>
                                    <span class="error-message">
                                        Você já respondeu essa enquete no dia
                                        <strong>
                                            {{
                                                lastAnswer.getDate() +
                                                "/" +
                                                (lastAnswer.getMonth() + 1)
                                            }} </strong
                                        >. Você poderá responder de novo
                                        <strong>
                                            {{
                                                nextAnswer.getDate() +
                                                "/" +
                                                (nextAnswer.getMonth() + 1)
                                            }}
                                            às
                                            {{
                                                nextAnswer.getHours() +
                                                ":" +
                                                nextAnswer.getMinutes()
                                            }}</strong
                                        ></span
                                    >
                                </div>
                            </div>
                        </template>
                        <template v-if="is('hasUnusedCoupon')">
                            <div class="intro already-answered">
                                <div class="block">
                                    <span class="icon icon-sad"></span> <br/>
                                    <span class="error-message">
                                        Você ainda tem um coupon de desconto não
                                        utilizado. Você poderá responder
                                        novamente após utilizar o coupon atual.
                                    </span>
                                </div>
                            </div>
                        </template>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.embed#form-page {
    background: transparent;
}
</style>
<script>
import keviApi from "./../keviApi";
import FormStep from "./step";
import FormUser from "./form-user";

export default {
    name: "Form",
    props: {
        client: Object,
    },
    data: function () {
        return {
            title: "",
            description: "",
            steps: [],
            stepActive: 0,
            state: "loading",
            id: null,
            saving: false,
            lastAnswer: null,
            nextAnswer: null,
            embed: false,
            custom_css: null,
            coupon: {
                code: null,
                expiration_date: null,
                text: null,
                how_to_use: null,
            },
        };
    },
    components: {
        "form-step": FormStep,
        "user-form": FormUser,
    },
    computed: {
        place() {
            return this.$store.state.place;
        },
        branchId() {
            return this.$route.query.branch_id || null;
        },
        showClientForm: function () {
            if (!this.client.first_name) {
                return true;
            }
            if (!this.client.email) {
                return true;
            }
            if (!this.client.birthdate) {
                return true;
            }
            return false;
        },
    },
    created: function () {
        document.getElementsByTagName("title")[0].innerText =
            "Kevi, sua opinião é muito importante!";
        this.updateForm();
        this.embed = parseInt(this.$route.query.embed) === 1;
        if (this.$route.params.place) {
            var options = keviApi.getOptions(
                "place/" + this.$route.params.place + "/public-info",
            );
            this.$http(options).then(
                function (response) {
                    if (response.status === 200) {
                        this.loading = false;
                        if (!response.body.logo) {
                            response.body.logo = "images/kevi.png";
                        }
                        if (!response.body.color) {
                            response.body.color = "#0f2f67";
                        } else {
                            response.body.color = "#" + response.body.color;
                        }
                        this.image = response.body.logo;
                        this.color = response.body.color;
                        this.$store.commit("setPlace", response.body);
                        this.$emit("found-place", response.body);
                    }
                },
                function () {
                    this.loading = false;
                },
            );
        }
    },
    methods: {
        isStepActive: function (step) {
            return this.stepActive === step ? true : false;
        },
        is: function (state) {
            return this.state === state;
        },
        setState: function (state) {
            this.state = state;
        },
        begin: function () {
            this.setState("answering");
        },
        next: function () {
            if (this.$refs.steps[this.stepActive].isValid()) {
                if (this.showClientForm) {
                    if (this.$refs.formUser.isValid()) {
                        this.save();
                    }
                } else {
                    this.save();
                }
            } else {
                var _self = this;
                window.setTimeout(function () {
                    _self.scrollStep(0, 1000);
                }, 500);
            }
        },
        save: function () {
            window.mixpanel?.track("Form save begin");
            this.saving = true;
            var data = this.getData();
            var options = keviApi.getOptions("answers", "PUT", data);
            this.$http(options).then((response) => {
                if (response.status === 200) {
                    this.saving = false;
                    this.coupon = response.body?.coupon;
                    if (response.body?.client) {
                        this.foundClient(response.body.client);
                    }
                  window.parent.postMessage({ type: "kevi-form-submitted", formId: this.id, result: response.body  }, "*");

                  this.setState("saved");
                    window.mixpanel?.track("Form saved", {
                        coupon: this.coupon,
                    });
                }
            });
        },
        foundClient: function (data) {
            this.$emit("found-client", data);
        },
        getData: function () {
            let data = {
                forms_id: this.id,
                clients_id: this.client.id,
                steps_questions: {},
            };
            if (this.$store.state.linkCode) {
                data.link_code = this.$store.state.linkCode.link_code;
            }
            if (this.branchId) {
                data.branch_id = this.branchId;
            }
            for (let s in this.$refs.steps) {
                let step = this.$refs.steps[s];
                for (let q in step.$refs.questions) {
                    let question = step.$refs.questions[q];
                    if (!question.isNull()) {
                        data["steps_questions"][question.name] =
                            question.getValue();
                    }
                }
            }
            if (this.showClientForm) {
                data.user = this.$refs.formUser.getData();
            }
            return data;
        },
        updateForm: function () {
            window.mixpanel?.track("Form loading");
            let data = {
                clients_id: this.client.clients_id,
            };
            let place =
                this.$route.params.place || this.$store.state.place.slug;
            if (this.$store.state.linkCode) {
                data.link_code = this.$store.state.linkCode.link_code;
            }
            if (this.$route.params.formId) {
                data.formId = this.$route.params.formId;
            }

            var options = keviApi.getOptions(
                "place/" + place + "/form",
                "GET",
                data,
            );
            this.$http(options).then(
                function (response) {
                    if (response.status === 200) {
                        window.mixpanel?.track("Form loaded");
                        if (response.body?.status === "success") {
                            this.$store.commit("clearAnswers");
                            this.$store.commit("setForm", response.body.form);
                            this.id = response.body.form.id;
                            this.steps = response.body.form.steps;
                            this.title = response.body.form.title;
                            this.description = response.body.form.description;
                            this.custom_css = response.body.form.custom_css;
                            window.mixpanel?.track("Form answer begin");
                            this.setState("answering");
                        } else if (
                            response.body?.status === "already-answered"
                        ) {
                            this.lastAnswer = new Date(
                                response.body.last_answer,
                            );
                            this.nextAnswer = new Date(
                                response.body.next_answer,
                            );
                            window.mixpanel?.track("Form already answered");
                            this.setState("alreadyAnswered");
                        } else if (response.body?.status === "unused-coupon") {
                            window.mixpanel?.track("Has unused coupon");
                            this.setState("hasUnusedCoupon");
                        } else {
                            this.setState("notFound");
                        }
                    }
                },
                function () {
                    this.setState("notFound");
                },
            );
        },

        scrollStep: function (scroll, duration) {
            if (duration === undefined) {
                duration = 200;
            }
            var to = scroll;
            this.scrollTo(window, to, duration);
        },

        scrollTo: function (element, to, duration) {
            if (duration) {
                if (duration <= 0) return;
                let difference = to - window.scrollY;
                let perTick = (difference / duration) * 10;

                setTimeout(() => {
                    let scrollY = window.scrollY + perTick;
                    window.scroll(0, scrollY);
                    if (element.scrollTop === to) return;
                    this.scrollTo(element, to, duration - 10);
                }, 10);
            }
        },

        clientUpdated: function (client) {
            this.$emit("found-client", client);
            this.setState("saved");
        },
    },
    watch: {
        steps: {
          handler() {
            //emit event to parent frame
            //if there is an iframe parent
            if (window.parent !== window) {
              this.$nextTick(() => {
                const form = document.querySelector("#form-page");
                //get height + scroll height
                const totalHeight = window.getComputedStyle(form).height;

                window.parent.postMessage({ type: "kevi-form-resize", formId: this.id, height: totalHeight }, "*");
              });
            }
          },
        },
        custom_css: {
            handler(newCss) {
                if (this.embed) {
                    let styleElement = document.getElementById("dynamic-custom-css");
                    if (!styleElement) {
                        styleElement = document.createElement("style");
                        styleElement.id = "dynamic-custom-css";
                        document.head.appendChild(styleElement);
                    }
                    // Set the CSS content
                    styleElement.innerHTML = newCss;
                }
            }
        }
    }
};
</script>
